import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { PAYMENT_ENV } from '@payments/app/core/tokens';
import { AuthService } from '@auth/app/core/services/auth.service';
import { startsWithApiBase } from '@auth/app/core/utils/api-url.util';

/** Injeta `X-Tenant-ID` nas chamadas ao payment-api autenticadas. */
export const paymentContextInterceptor: HttpInterceptorFn = (req, next) => {
  const paymentEnv = inject(PAYMENT_ENV);

  const isPaymentApi = startsWithApiBase(req.url, paymentEnv.url);
  if (!isPaymentApi) {
    return next(req);
  }

  const context = inject(AuthService).getContext();
  if (!context) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        'X-Tenant-ID': context.tenantId,
      },
    }),
  );
};
